import React from 'react';
import { Header } from 'semantic-ui-react';

type Props = Readonly<{ curso: { nombre: string; bloque: string } }>;

export const HeaderNombreDeCurso = (props: Props) => {
    const { curso } = props;

    return (
        <Header as='h1' textAlign='center'>
            {curso.nombre}
            <Header.Subheader>{mapaDeNombresDeBloques[curso.bloque]}</Header.Subheader>
        </Header>
    );
};

const mapaDeNombresDeBloques: Record<string, string> = {
    MA1: 'Matemática 1 - anual',
    MA2: 'Matemática 2 - anual',
    LA1: 'Lenguaje 1 - anual',
    LA2: 'Lenguaje 2 - anual',
    HA1: 'Historia 1 - anual',
    HA2: 'Historia 2 - anual',
    BA: 'Biología - anual',
    FA: 'Física - anual',
    QA: 'Química - anual',
    MI1: 'Matemática 1 - intensivo',
    MI2: 'Matemática 2 - intensivo',
    LI1: 'Lenguaje 1 - intensivo',
    LI2: 'Lenguaje 2 - intensivo',
    HI1: 'Historia 1 - intensivo',
    HI2: 'Historia 2 - intensivo',
    BI: 'Biología - intensivo',
    FI: 'Física - intensivo',
    QI: 'Química - intensivo',
    MV1: 'Matemática 1 - intensivo vesp.',
    MV2: 'Matemática 2 - intensivo vesp.',
    LV1: 'Lenguaje 1 - intensivo vesp.',
    LV2: 'Lenguaje 2 - intensivo vesp.',
    HV1: 'Historia 1 - intensivo vesp.',
    HV2: 'Historia 2 - intensivo vesp.',
    BV: 'Biología - intensivo vesp.',
    FV: 'Física - intensivo vesp.',
    QV: 'Química - intensivo vesp.',
    BE: 'Biología - electivo',
    FE: 'Física - electivo',
    QE: 'Química - electivo',
};



// WEBPACK FOOTER //
// ./src/modulos/Horarios/componentes/HeaderNombreDeCurso.tsx